import { call, put, takeLatest, select } from 'redux-saga/effects';
import { getTranslations } from '~/locales';
import * as actions from '../actions';
import {
  GET_HOME_CHARGERS,
  GET_HOME_CHARGERS_V2,
  GET_LOCATIONS_DETAIL,
  GET_LOCATIONS,
  GET_LOCATIONS_V2,
  GET_3RD_PARTY_CHARGERS,
  GET_SELECTED_LOCATION_DETAIL,
} from '../types';
import {
  getLocationsApi,
  getHomeChargersApi,
  getLocationsV2Api,
  getHomeChargersV2Api,
  get3rdPartyChargersApi,
  getSelectedLocationDetailApi,
  getLocationsDetailApi,
} from '../../api';

export function* getLocationsSaga() {
  try {
    const {
      Data: { csrfToken },
    } = yield select();
    const response = yield call(getLocationsApi, csrfToken);
    if (!response?.data?.success) yield put(actions.getLocationsFailure());
    yield put(actions.getLocationsSuccess(response?.data?.data));
  } catch (e) {
    yield put(actions.getLocationsFailure());
  }
}

export function* getHomeChargersSaga({ payload }) {
  const {
    Data: { csrfToken },
  } = yield select();
  try {
    const response = yield call(getHomeChargersApi, csrfToken, payload);
    if (!response?.data?.success) yield put(actions.getHomeChargersFailure());
    yield put(actions.getHomeChargersSuccess(response?.data?.data));
  } catch (e) {
    yield put(actions.getHomeChargersFailure());
  }
}

export function* getLocationsV2Saga() {
  try {
    const {
      Data: { csrfToken },
    } = yield select();
    const response = yield call(getLocationsV2Api, csrfToken);
    if (!response?.data?.success) {
      yield put(actions.getLocationsFailure());
    } else {
      yield put(actions.getLocationsSuccess(response?.data?.data));
    }
  } catch (e) {
    yield put(actions.getLocationsFailure());
  }
}

export function* getHomeChargersV2Saga({ payload }) {
  const {
    Data: { csrfToken },
  } = yield select();
  try {
    // Home charger lookup (V2) is now available to all users.
    // Previously restricted to Tesla One Sales users via source + userToken.
    const response = yield call(getHomeChargersV2Api, csrfToken, payload);
    if (!response?.data?.success) {
      yield put(actions.getHomeChargersFailure());
    } else {
      yield put(actions.getHomeChargersSuccess(response?.data?.data));
    }
  } catch (e) {
    yield put(actions.getHomeChargersFailure());
  }
}

export function* get3rdPartyChargersSaga({ payload }) {
  const {
    Data: { csrfToken, locale },
  } = yield select();

  const { location: locationTranslations } = getTranslations(locale);

  try {
    const response = yield call(get3rdPartyChargersApi, csrfToken, payload);
    if (!response?.data?.success) {
      yield put(actions.get3rdPartyChargersFailure());
    } else {
      const filteredData = response?.data?.data?.filter(
        item => item?.detail_info?.brand !== locationTranslations.filterBrand
      );
      yield put(actions.get3rdPartyChargersSuccess(filteredData));
    }
  } catch (e) {
    yield put(actions.get3rdPartyChargersFailure());
  }
}

export function* getSelectedLocationDetailSaga({ payload }) {
  const {
    Data: { csrfToken },
  } = yield select();
  try {
    const response = yield call(getSelectedLocationDetailApi, csrfToken, payload);
    if (!response?.data?.success) {
      yield put(actions.getSelectedLocationDetailFailure());
    } else {
      yield put(actions.getSelectedLocationDetailSuccess(response?.data?.data));
    }
  } catch (e) {
    yield put(actions.getSelectedLocationDetailFailure());
  }
}

export function* getLocationsDetailSaga({ payload }) {
  const {
    Data: { csrfToken },
  } = yield select();
  try {
    const response = yield call(getLocationsDetailApi, csrfToken, payload);
    if (!response?.data?.success) {
      yield put(actions.getLocationsDetailFailure());
    } else {
      yield put(actions.getLocationsDetailSuccess(response?.data?.data));
    }
  } catch (e) {
    yield put(actions.getLocationsDetailFailure());
  }
}

const locationsSaga = [
  takeLatest(GET_LOCATIONS, getLocationsSaga),
  takeLatest(GET_LOCATIONS_V2, getLocationsV2Saga),
  takeLatest(GET_HOME_CHARGERS, getHomeChargersSaga),
  takeLatest(GET_HOME_CHARGERS_V2, getHomeChargersV2Saga),
  takeLatest(GET_3RD_PARTY_CHARGERS, get3rdPartyChargersSaga),
  takeLatest(GET_SELECTED_LOCATION_DETAIL, getSelectedLocationDetailSaga),
  takeLatest(GET_LOCATIONS_DETAIL, getLocationsDetailSaga),
];

export default locationsSaga;
